// extracted by mini-css-extract-plugin
export default {"contents":"hH-z","sectionHeading":"iH-z"};